import { Pipe, PipeTransform } from '@angular/core';
import { getBaseAssetCode } from '@shared/utils/assets';

@Pipe({
  standalone: true,
  name: 'basePairIcon',
})
export class BasePairIconPipe implements PipeTransform {
  public transform(pairName?: string): string {
    return getBaseAssetCode(pairName);
  }
}
